import { render, staticRenderFns } from "./UserScorableRangeList.vue?vue&type=template&id=20169639&"
import script from "./UserScorableRangeList.vue?vue&type=script&lang=ts&"
export * from "./UserScorableRangeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports